// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = require("jquery")

$(() => {
  if (window.location.hash) {
    const anchor = document.querySelector(window.location.hash)

    if (anchor) {
      anchor.scrollIntoView()
    }
  }
})
